import { render, staticRenderFns } from "./CustomCrumbs.vue?vue&type=template&id=2b0cecd7&scoped=true"
import script from "./CustomCrumbs.vue?vue&type=script&lang=js"
export * from "./CustomCrumbs.vue?vue&type=script&lang=js"
import style0 from "./CustomCrumbs.vue?vue&type=style&index=0&id=2b0cecd7&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0cecd7",
  null
  
)

export default component.exports